import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import { getVar } from '../../theme/ui-variables/ui-variables';

const StyledH2 = styled.h2`
  margin-top: 3rem;
`;

const StyledText = styled.p`
  margin-top: 1rem;
  margin-bottom: 3rem;
  max-width: 39rem;
`;

const StyledButton = styled(Button)`
  border-radius: ${getVar('borderRadius')} !important;
  padding: 1.5rem 3.5rem !important;
  box-shadow: none !important;
  margin-top: 3rem !important;
  max-width: 39rem;
`;

export const StyledBlockedLocationDialog = {
  StyledH2,
  StyledText,
  StyledButton,
};
